import { z } from "zod";

/** Shared name field for party create — plan/26 RHF + Zod. */
export const partyNameSchema = z.object({
  name: z.string().trim().min(1, "Name is required"),
});

export const partyCreateSchema = partyNameSchema
  .extend({
    isCustomer: z.boolean(),
    isSupplier: z.boolean(),
    priceListId: z.string().optional(),
  })
  .refine((d) => d.isCustomer || d.isSupplier, {
    message: "Select at least one role",
    path: ["isCustomer"],
  });

/** @deprecated Prefer partyCreateSchema — kept for customer-only create forms. */
export const customerCreateSchema = partyNameSchema.extend({
  priceListId: z.string().optional(),
});

export type PartyNameInput = z.input<typeof partyNameSchema>;
export type PartyCreateInput = z.input<typeof partyCreateSchema>;
export type CustomerCreateInput = z.input<typeof customerCreateSchema>;
